'use strict';
import angular from 'angular';
import confirmHtmlUrl from '../../../views/directives/confirm.html';

angular.module('app.services')

        .service('$confirm', ['$q', '$modal', function($q, $modal) {
            var myAlert;

            // Message is a message object, that expects a size, message, and options.
            // Options will be displayed in an ng-repeat as a checkbox (for now)
            this.open = function(message){

                var deferred = $q.defer();

                var modalInstance = $modal.open({
                    animation: true,
                    templateUrl: confirmHtmlUrl,
                    controller: 'ConfirmModalController',
                    size: message.size ? message.size : 'sm',
                    resolve: {
                        message: function () {
                            return message;
                        }
                    }
                });

                modalInstance.result.then(function (status) {
                    deferred.resolve(status);
                }, function () {
                    //modal dismissed
                    deferred.reject();
                });

                return deferred.promise;
            };

            return this;

        }]);